// @ts-nocheck
import splitOrderCartLineReducer, {
    GreifSubmitAndReviewPagesReducerSplitOrderCartLineActions,
} from "@store/Framework/Store/Greif/Pages/ReviewAndSubmit/SplitOrderCartLine/SplitOrderCartLineReducer";
import { combineReducers } from "redux";

const reviewAndSubmitReducers = {
    splitOrderCartLine: splitOrderCartLineReducer,
};

export type GreifPagesSubmitAndReviewActions = GreifSubmitAndReviewPagesReducerSplitOrderCartLineActions;
export default combineReducers(reviewAndSubmitReducers);
